export default "__VITE_ASSET__53fc9971__"